export class AutocompleteOptionInterface {
    label: string;
    value: number|string|number[]|string[];
    classes?: string;
}
